module.exports = __webpack_public_path__ + "img/exercise_animation.fb5c44c8.svg";